"use strict";
'use es6';
/**
 * @param {Array} arr
 * @param {*} fulcrum
 * @return A copy of the given array "rotated" so that the `fulcrum` is the first entry and the
 * entry before the `fulcrum` is the last
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rotateAround = void 0;

var rotateAround = function rotateAround(arr, fulcrum) {
  var fulcrumIndex = arr.indexOf(fulcrum);
  return fulcrumIndex === -1 ? arr : arr.slice(fulcrumIndex).concat(arr.slice(0, fulcrumIndex));
};

exports.rotateAround = rotateAround;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/utils/Arrays.js
// module id = 673
// module chunks = 209 210 211 212